/**
 * limitValue limit a value between two defined values
 *
 * @deprecated Do not use legacy components anymore.
 * @param {number} value to limit
 * @param {number} value1 first number(max or min)
 * @param {number} value2 second number(max or min)
 *
 * @returns {number} the limited value
 */
var limitValue = function (value, value1, value2) {
    var max;
    var min;
    if (value1 < value2) {
        max = value2;
        min = value1;
    }
    else {
        max = value1;
        min = value2;
    }
    if (value < min) {
        value = min;
    }
    else if (value > max) {
        value = max;
    }
    return value;
};
export default limitValue;
//# sourceMappingURL=limitValue.js.map